import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../../theme';
import { FA_SELECTOR } from '../../../styles/variables';
import { defBtnDisabled } from '../../../styles/mixins';

export const useShipmentTemplatesCardStyles = createStyles(({ token }) => ({
  shipmentTemplatesCard: {
    '.ConfigurableCard-Body': {
      padding: `${token.paddingMD / 2}px ${ThemeSpaces.SPACE_NORM}px`,
    },

    '.ant-btn': {
      width: 130,

      [FA_SELECTOR]: {
        color: token.colorPrimary,
      },
      ...defBtnDisabled({
        [FA_SELECTOR]: {
          color: 'inherit',
        },
      }),
      span: {
        lineHeight: 1,
      },
    },
  },
}));
